export const PHOTOS_COUNT_PER_PAGE = 20
export const ALBUMS_COUNT_PER_PAGE = 20